import axios from 'axios'
import router from '@/router'
import { Message, MessageBox } from 'element-ui'
import { config } from '@/api/config'
import { refreshToken } from '@/api/login'
import { setSession, delSession, getSession, isTokenExpire } from '@/api/common'
import { showErrorMsg } from '@/util/msgConst'
import store from '../store/index'
import { CHAT } from '@/common/websocket/index'
import { loginClose } from '@/common/rtc/mediasoup/mediasoup-util'
import { outClose } from '@/common/rtc/mediasoup/mediasoup-walkie'
import { loginOutCloseSig } from '@/common/rtc/srs/video-platform'
import { closeVideoWalkie } from '@/common/rtc/srs/video-walkie'
import qs from 'qs'
const isDev = process.env.NODE_ENV === 'development'
const oauthLogin = 'oauth/login'
const oauthToken = 'oauth/token'
// 后台多语言类型转换
const translateLanguage = {
  zh: 'zh-CN', //中文简体
  tw: 'zh-HK', //中文翻译（台湾）
  hk: 'zh-HK', //中文翻译（香港）
  en: 'en-US', //英语
}
// 是否正在刷新的标志
let isTokenRefreshing = false
// 存储请求的数组
let subscribesArr = []
// 请求push到数组中
function subscribesArrRefresh(cb) {
  subscribesArr.push(cb)
}
// 用新token发起请求
function reloadSubscribesArr(newToken) {
  subscribesArr.map(cb => cb(newToken))
}
function clearCache() {
  // 出现请求错误，清除缓存，退出登录
  isTokenRefreshing = false
  subscribesArr = []
  delSession('access_token')
  delSession('expireTime')
  delSession('HWSecurity_access_token')
  sessionStorage.removeItem('featureCode')
  sessionStorage.removeItem('isAdmin')
  sessionStorage.removeItem('account')
  if (
    window.location.href.includes('/realvideo') ||
    window.location.href.includes('/Intercom') ||
    window.location.href.includes('/externalHistory')
  ) {
    // router.push('/realvideo')
  } else {
    router.push('/Login')
  }
  // 关闭语音通话/广播弹窗
  store.commit('voiceShow', false)
  // 关闭对讲
  store.commit('walkieShow', false)
  let message = document.getElementsByClassName('el-message-box')
  if (message.length > 0) {
    MessageBox.close(false)
  }
  loginClose()
  outClose()
  // 退出关闭 srs新媒体平台信令
  loginOutCloseSig()
  closeVideoWalkie()
}
export default router => {
  // axios 配置
  // axios.defaults.timeout = 5000
  axios.defaults.headers.post['Content-Type'] = 'application/json'
  // axios.defaults.headers.common['Authorization'] = 'bearer '+ localStorage.getItem('currentUser_token')

  // 配置运行环境路径  配合apache使用
  if (!isDev) {
    axios.defaults.baseURL = config.ihUrlApache
  }

  // http request 拦截器
  axios.interceptors.request.use(
    config => {
      // 特殊处理参数
      let urlStr = config.url
      // console.log('urlStr特殊处理参数', urlStr)
      if (config.method === 'get' && config.params) {
        config.paramsSerializer = function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }
      let _accessToken = getSession('access_token')
      if (_accessToken && urlStr.indexOf(oauthLogin) === -1 && urlStr.indexOf(oauthToken) === -1) {
        config.headers.Authorization = _accessToken
      } else if (
        getSession('HWSecurity_access_token') &&
        urlStr.indexOf(oauthLogin) === -1 &&
        urlStr.indexOf(oauthToken) === -1
      ) {
        config.headers.Authorization = getSession('HWSecurity_access_token')
      }
      // 入参多语言
      let language = localStorage.getItem('lang') || 'zh'
      let lang = translateLanguage[language]
      config.headers.lang = lang
      let serverTokenExpire = getSession('expireTime')
      // 判断token是否过期
      if (serverTokenExpire && isTokenExpire(serverTokenExpire) && urlStr.indexOf(oauthToken) === -1) {
        // 判断token是否已经刷新过
        if (!isTokenRefreshing) {
          isTokenRefreshing = true
          // 请求刷新token
          let params = {
            refresh_token: getSession('refresh_token'),
            grant_type: 'refresh_token',
          }
          refreshToken(params)
            .then(_res => {
              isTokenRefreshing = false
              let state = _res.state
              if (state === 0) {
                let res = _res
                setSession('access_token', res.token_type + ' ' + res.access_token)
                setSession('refresh_token', res.refresh_token)
                delSession('expireTime')
                setSession('expireTime', res.expiration)
                reloadSubscribesArr(res.token_type + ' ' + res.access_token)
                // 清空数组中保存的请求
                subscribesArr = []
              } else {
                clearCache()
              }
            })
            .catch(err => {
              // 请求失败，清空缓存，返回登录页
              clearCache()
            })
        }
        return new Promise((resolve, reject) => {
          subscribesArrRefresh(Token => {
            config.headers.Authorization = Token
            resolve(config)
          })
        })
        // return retry
      } else {
        return config
      }
    },
    err => {
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  axios.interceptors.response.use(
    response => {
      // console.log('response', response)
      let status = response.status
      let result = response.data
      if (status !== 200) {
        if (status === 401 || status === 402) {
          if (
            !response.config.url.includes('hwmsp/media/api/media') &&
            !response.config.url.includes('/medias/save/code')
          ) {
            localStorage.clear()
            clearCache()
          }
        }
      }
      if (result['state'] && result['state'] !== 0) {
        let msg = showErrorMsg(result['state'])
        if (window.location.href.includes('/realvideo')) {
          console.log(msg)
        } else {
          Message({
            type: 'error',
            message: msg,
            duration: 2000,
            customClass: 'zZindex',
          })
        }
        try {
          if (getSession('access_token') === null) {
            clearCache()
            if (window.CHAT.socket) {
              window.CHAT.socket.close()
            }
            CHAT.wsclose()
          } else {
            window.CHAT.reconnect()
          }
        } catch (error) {
          console.log(error)
        }
      }
      if (response.data['data']) {
        response.data['value'] = response.data['data']
      }
      return response
    },
    err => {
      if (err && err.response) {
        // err.title = '账号信息错误'
        switch (err.response.status) {
          case 400:
            err.message = errorForParams(err)
            break
          case 401:
            // iframe里401时与外部通信更新
            if (window.location.href.indexOf('access_token') !== -1) {
              return false
            } else {
              if (err.response.config.url.includes('/login')) {
                if (err.response.data && err.response.data.msg === '认证失败') {
                  err.message = '用户名或密码错误'
                } else {
                  err.message = err.response.data.msg
                }
              } else {
                if (getSession('access_token')) {
                  err.message = '请重新登录'
                }
                clearCache()
              }
            }
            break
          case 402:
            err.message = '认证过期, 请重新登录'
            clearCache()
            break
          case 403:
            err.message = '拒绝访问'
            break

          case 404:
            err.message = '请求的服务不存在，请联系管理员'
            break

          case 405:
            err.message = '请求的服务不存在，请联系管理员'
            break

          case 408:
            err.message = '请求超时'
            break

          case 500:
            if (err.response.data.msg) {
              err.message = `${err.response.data.msg}`
            } else if (err.response.data.errorMessage) {
              err.message = `<h3>${err.response.data.errorMessage}</h3><br><span>服务器内部错误</span>`
            } else {
              err.message = '服务器内部错误'
            }
            break

          case 501:
            err.message = '服务未实现'
            break

          case 502:
            err.message = '连接服务端超时或异常，请稍后重试'
            break

          case 503:
            err.message = '服务暂不可用，请联系管理员'
            break

          case 504:
            if (err.response.config.url.indexOf('tianditu') === -1) {
              err.message = '网关超时'
            } else {
              err.message = ''
            }

            break

          case 505:
            err.message = 'HTTP版本不受支持'
            break

          default:
        }
      }
      console.log(err.response)
      if (!!err.response.data && !!err.response.data.msg) {
        // err.title = err.response.data.msg
        err.title = err.response.data.msg
        if (err.message === '用户名或密码错误') {
          err.title = '错误'
        }
        if (err.response.data.value !== null) {
          // 只显示第一条错误消息
          const val = err.response.data.value
          for (let key in val) {
            err.message = val[key]
            break
          }
        }
      }
      let urlStr = err.config.url
      if (urlStr.indexOf(oauthLogin) === -1 && urlStr.indexOf('api.tianditu') === -1) {
        if (window.location.href.includes('/realvideo') || window.location.href.includes('/Login')) {
          console.log(err.message)
        } else if (err.message !== '服务器内部错误') {
          Message({
            dangerouslyUseHTMLString: true,
            message: err.message,
            type: 'error',
            duration: 2000,
          })
        } else {
          console.log(err)
        }
      }
      return Promise.reject(err)
    }
  )
  return axios
}

function errorForParams(er) {
  let msg = null
  const data = er.response.data
  if (data !== null) {
    if (data.value && data.value !== undefined) {
      // 只显示第一条错误消息
      for (const key in data.value) {
        msg = data.value[key]
        break
      }
    } else {
      // 账号密码错误时返回400
      if (data.msg !== undefined) {
        msg = data.msg
      } else {
        msg = '参数不合法'
      }
    }
  } else if (er.msg !== null) {
    msg = er.msg
  } else {
    msg = '系统异常，请联系管理员'
  }
  return msg
}
